/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkAddBrands} from '../api'

export const useMutationBulkAddBrands = createReactQueryMutationHook('bulkAddBrands', bulkAddBrands)
